import useAuth from "../../hooks/useAuth";
import AuthGuard from "./AuthGuard";
import React from "react";
import { Navigate } from "react-router-dom";

// For routes that can only be accessed by authenticated super users
const SuperUserGuard = ({ children }) => {
  const { isSuperuser } = useAuth();

  if (!isSuperuser) {
    return <Navigate to="/" />;
  }

  return (
    <AuthGuard>
      <React.Fragment>{children}</React.Fragment>
    </AuthGuard>
  );
};

export default SuperUserGuard;
